import { Component } from '@angular/core';
import { EventService } from './services/event.service';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { LanguageService } from './services/language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  constructor(
    private languageService: LanguageService
  ) {}
}
